<template>
  <header class="contact-header p-4">
    <h1 class="fall-down">CONTACT</h1>
    <p class="image-fade-in">
      Une question sur notre service de <strong>livraison ?</strong> Une
      <strong>Démo en live</strong><span class="fake-space">?</span
      ><br />N'hésitez pas on répond à toutes vos questions.
    </p>
  </header>
  <div class="img-header">
    <img src="@/assets/brand/logo-y.webp" alt="logo livratos" />
  </div>
</template>

<script>
export default {
  name: "ContactHeader",
};
</script>

<style lang="scss" scoped>
.contact-header {
  margin-top: 100px !important;
  height: 30vh;
  /*background-image: url("@/assets/pictures/brain-particule.webp");
  background-size: contain;
  @media screen and (min-width: 992px) {
    background-size: cover;
  }
  background-repeat: no-repeat;
  background-position: center center;*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & h1 {
    color: $color-primary;
    font-size: 3em;
    text-align: center;
  }
  & p {
    color: $color-text;
    font-size: 1.3em;
    text-align: center;
    & .fake-space {
      margin-left: 8px;
    }
  }
}
.img-header {
  display: flex;
  justify-content: center;
  align-items: center;
  & img {
    margin-top: -70px;
    width: 300px;
  }
}
</style>
